module.exports = __webpack_public_path__ + "static/media/armadillo-logo-mark.794b4fcc.svg";